import { NeoState } from '~/store';
import { createSelector } from 'reselect';
import { keyBy } from 'lodash-es';

export const selectEventGroup = (id: string) => (state: NeoState) =>
  state.eventGroups.item?.id === id ? state.eventGroups.item : null;

export const selectEventGroupsList = (state: NeoState) => state.eventGroups.list;

export const selectSyncedEventGroupsList = (state: NeoState) => state.eventGroups.syncedList;

export const selectNextEventsMap = (state: NeoState) => state.eventGroups.nextEventsMap;

export const selectSyncedEventGroupsMap = createSelector(
  selectSyncedEventGroupsList,
  (syncedEventGroup) => keyBy(syncedEventGroup, 'eventGroupId'),
);
